/* eslint-disable import/prefer-default-export */

export const URL_ARRAY_SEPARATOR = '/';
